<div class="container">
  <div class="user-list mt-3 mb-3 table-responsive" *ngIf="coupons.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th class="text-center" scope="col">#</th>
        <th class="text-center" scope="col">Code</th>
        <th class="text-center" scope="col">Extra Lessons Number</th>
        <th class="text-center" scope="col">Used By User Id</th>
        <th class="text-center" scope="col">Used Subscription Id</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let coupon of coupons">
        <td class="text-center">{{ coupon.id }}</td>
        <td class="text-center">{{ coupon.code }}</td>
        <td class="text-center">{{ coupon.extraLessonsNumber }}</td>
        <td class="text-center">{{ coupon.usedByUserid }}</td>
        <td class="text-center">{{ coupon.usedByPurchasedSubscriptionId }}</td>
        <td class="text-center">
          <button [disabled]="!!coupon.usedByUserid" type="button" class="btn btn-light edit-button"
                  (click)="openEditModal(coupon)">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td>
          <button type="button" class="btn btn-danger delete-button" (click)="openDeleteConfirmModal(coupon)">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="user-list mt-3 mb-3" *ngIf="coupons.length == 0">
    <p>You have no coupons yet</p>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-default add-button" (click)="openEditModal(null)">
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
</div>
